import moment from "moment";
import { useCallback, useState } from "react";
import { CustomCellRendererProps } from "ag-grid-react";
import { Box, Paper, Typography, makeStyles } from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import locale from "@bonliva-crm/locale";
import { CircleIcon, Color, WithPopper } from "@bonliva-crm/ui";
import { MarkHighlighter } from "@common";
import { ConsultantRowData } from "../../../utils/consultant-row-data";

export const CommentSearchResultRenderer = (
  props: CustomCellRendererProps<ConsultantRowData>
) => {
  const classes = useStyles();

  const [markjsContext, setMarkjsContext] = useState<NodeListOf<Element>>();

  const contentRef = useCallback((node: HTMLDivElement) => {
    if (node !== null) {
      setMarkjsContext(node.querySelectorAll(".highlighter"));
    }
  }, []);

  const eventsLength = props.data?.Events?.length;
  if (!props.context?.highlightText) return;
  if (!eventsLength) return;

  const cellContent = (
    <Box height="100%" width="100%">
      <MarkHighlighter
        highlightSearch={props.context.highlightText}
        getMarkjsContext={() => markjsContext}
      />

      <div className={classes.infoContainer}>
        <Typography variant="body1">
          {eventsLength}{" "}
          {(eventsLength === 1 ? locale.Comment : locale.Comments).toLowerCase()}
        </Typography>

        <InfoOutlinedIcon />
      </div>
    </Box>
  );

  const popupContent = (
    <Paper
      ref={contentRef}
      style={{ maxWidth: "30rem", maxHeight: "50vh", overflowY: "auto" }}
    >
      {props.data?.Events?.map((event) => {
        return (
          <Box className={classes.item} key={`commentSearchResult${event._id}`}>
            <Box display="flex" alignItems="center">
              <Typography variant="subtitle1" className="highlighter">
                {event.CreatedBy.Name}
              </Typography>

              {event.CreatedOn && (
                <>
                  <CircleIcon
                    htmlColor={Color.DetailsInput}
                    style={{
                      width: "4px",
                      height: "4px",
                      marginLeft: "4px",
                      marginRight: "4px"
                    }}
                  />

                  <Typography variant="subtitle1">
                    {moment(event.CreatedOn).format("DD MMMM HH:mm")}
                  </Typography>
                </>
              )}
            </Box>

            <Typography
              variant="body1"
              dangerouslySetInnerHTML={{ __html: event.DescriptionHtml }}
              className="highlighter"
            />
          </Box>
        );
      })}
    </Paper>
  );

  return (
    <WithPopper
      behaviour="hover"
      placement="right"
      rootStyle={{ height: "100%" }}
      popperContent={popupContent}
    >
      {cellContent}
    </WithPopper>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    // marginTop: "0.5rem"
  },
  infoContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "0.25rem"
  },
  item: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    padding: 8
  }
}));
